// Copyright (c) Hamilton Manufacturing Corp.

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { isMobile } from '../api/utility';
import Icon from './Icon';

const ButtonCSS = styled.button`
    display: flex;
    align-items: center;
    margin: 0.5em;
    padding: ${({ mobile }) => mobile ? '0.5em' : '0.1em'} 1em;
    color: ${({ theme }) => theme.button.text};
    cursor: pointer;
    border: unset;
    border-radius: 25rem;
    user-select: none;
    transition: background-color, transform, 0.3s;
    background-color: ${({ theme }) => theme.button.background};
    font-weight: bold;
    font-size: 1em;
    overflow: hidden;
    min-height: 1.2em;

    ${({ mobile, theme }) => !mobile ? `
    &:hover:enabled {
        box-shadow: 0px 3px 10px #00000029;
        background-color: ${theme.button.hover};
        color: ${theme.button.hoverText};
    }` : null}

    &:active:enabled {
        /*color: ${({ theme }) => theme.button.hover};*/
        background-color: ${({ theme }) => theme.button.active};
    }
    &:disabled {
        color: ${({ theme }) => theme.button.disabledText};
        background-color: ${({ theme }) => theme.button.disabled};
        transform: unset;
        box-shadow: unset;
        cursor: default;
    }
`;

const A = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: transparent;
    text-decoration: none;
	color: inherit;
	border: none;
	font: inherit;
	cursor: inherit;
	outline: inherit;
`;

const LinkA = A.withComponent(Link);

const I = styled(Icon)`
    margin: 0 0.2em;
`;

const Button = ({ to, children, ...props }) => {
    return (
        <ButtonCSS
            mobile={isMobile()}
            {...props}
        >
            {
                (to && !props.disabled) ?
                    <LinkA
                        to={to}
                    >
                        {props.icon ? <I icon={props.icon} /> : null}
                        {children}
                    </LinkA> :
                    <A
                        href={props.href}
                        target={props.target}
                    >
                        {props.icon ? <I icon={props.icon} /> : null}
                        {children}
                    </A>
            }
        </ButtonCSS >
    )
}

export default Button;